import { GetOrganizationSummaryResponseBodyType } from "@intelligems/ig-types/functions/organization-summaries/get-organization-summary";
import { useGetOrg } from "@src/api/organizations/get-organization";
import { organizationsKeys } from "@src/api/queryKeys";
import { useSuspenseQuery } from "@tanstack/react-query";

import { api } from "../api";

const getOrganizationSummary = async () => {
  const resp = await api.get<GetOrganizationSummaryResponseBodyType>(
    `/v2/organizations/subscriptions`
  );
  return resp.data;
};

export const useGetOrganizationSummary = () => {
  const org = useGetOrg();
  return useSuspenseQuery<GetOrganizationSummaryResponseBodyType>({
    queryKey: organizationsKeys.orgSummary(org.data.org.id),
    queryFn: async () => getOrganizationSummary(),
    refetchOnWindowFocus: "always",
  });
};
